<check-box 
           [view]="queryView"
           (onValueChange)="notifyValueChange($event)">
</check-box>
